import React, { useState, useEffect, useRef } from "react";
import back_arrow from "../../assets/svg/back-arrow.svg";
import plus_icon from "../../assets/svg/plus_icon.svg";
import "../../styles/invoice_addnew.css";
import { useNavigate, useLocation } from "react-router-dom";
import upload_icon from "../../assets/svg/upload_icon.svg";
import excel_icon from "../../assets/svg/excel_icon.svg";
import small_line from "../../assets/svg/small_line.svg";
import delete_icon from "../../assets/svg/delete_icon.svg";
import info_icon from "../../assets/svg/info_icon.svg";
import download_arrow from "../../assets/svg/download_arrow.svg";
import Invoice_header from '../Header/Invoice_header'
import axios from "axios";
import { ToastContainer, toast } from "react-toastify"
import axiosInstance from "../../axiosInstance";
import CreateJobs from "./CreateJobs";
import { usePermissions } from "../../hooks/PermissionContext";
import PermissionWrapper from "../../hooks/PermissionWrapper";
import AdditionalPermissionWrapper from "../../hooks/AdditionalPermissionWrapper";
import GenerateInvoiceHeader from "./GenerateInvoiceHeader";
import AsyncSelect from "react-select/async";
import { components } from 'react-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import MergedCharges from "./MergedCharges";
import SeparateInvoice from "./SeparateInvoice";
import ConfirmDialog from "../../ConfirmDialog/ConfirmDialog";
import CommonFooter from "../../CommonFooter/CommonFooter";
import MergedChargesTooltip from "./MergedChargesTooltip";
import "../../styles/MergedChargesTooltip.css"
import { FiInfo } from "react-icons/fi";
import SeparateChargesTooltip from "./SeparateChargesTooltip";
import useAttachmentValidator from "../AttachmentValidator/AttachmentValidator";
import { SquarePen } from "lucide-react";
import CommonRemarkPopup from "../../CommonRemarkPopup/CommonRemarkPopup";
import SapCsvSafeInput from "../../CommonRemarksRestriction/SapCsvSafeInput";

const GenerateSalesInvoice = () => {

  let ModuleId = 24
  const { getModulePermission } = usePermissions();
  const permission = getModulePermission(ModuleId);
  console.log("activeModuleId", ModuleId);

  console.log("permission", permission);
  const { hasAdditionalPermission } = usePermissions();
  // const canEditCharges = hasAdditionalPermission(ModuleId, "edit_inv_charges");
  // console.log("canEditCharges", canEditCharges);
  const { validateAttachments } = useAttachmentValidator();
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  const [selectedJobs, setSelectedJobs] = useState([]);
  const [selectedJobId, setSelectedJobId] = useState([]);
  const [jobInputValue, setJobInputValue] = useState('');
  const [selectedJobOptions, setSelectedJobOptions] = useState([]);
  const [selectedJobIds, setSelectedJobIds] = useState([]);
  const [billingNature, setBillingNature] = useState("");
  const [supplyPeriod, setSupplyPeriod] = useState(null);
  const [show, setShow] = useState(false);
  const [separateChargesShow, setSeparateChargesShow] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [isJobDropdownOpen, setIsJobDropdownOpen] = useState(false);
  const [summary, setSummary] = useState([]);
  const [initialSelectedJobs, setInitialSelectedJobs] = useState([]);
  const [lineitems, setLineitems] = useState([]);
  const [allCategories, setAllCategories] = useState([]);
  const [projectName, setProjectName] = useState("");
  const [projectId, setselectedprojectId] = useState(0);
  const [selectedChargeIds, setSelectedChargeIds] = useState({});
  const [suggestionsMap, setSuggestionsMap] = useState({}); // index => suggestions
  const [showSuggestionsMap, setShowSuggestionsMap] = useState({});
  const [inputValues, setInputValues] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const [showaddPopup, setShowAddPopup] = useState(false);
  const [showCreateJobPopup, setShowCreateJobPopup] = useState(false);
  const [newlyCreatedJobs, setNewlyCreatedJobs] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [salesHeaderRemarks, setSalesHeaderRemarks] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [restoredJobLineIdMap, setRestoredJobLineIdMap] = useState({});
  const [backdatedDays, setBackdatedDays] = useState(0);
  const [isSeparateInvoicePopupOpen, setIsSeparateInvoicePopupOpen] = useState(false);
  const [isMergedListPopupOpen, setIsMergedListPopupOpen] = useState(false);
  const [mergedChargesData, setMergedChargesData] = useState([]);
  const [isLoadingMergedCharges, setIsLoadingMergedCharges] = useState(false);
  const [separateChargesData, setSeparateChargesData] = useState([]);
  const [isLoadingSeparateCharges, setIsLoadingSeparateCharges] = useState(false);
  const [showMergeConfirm, setShowMergeConfirm] = useState(false);
  const [confirmAction, setConfirmAction] = useState(null);
  const [showRemarkPopup, setShowRemarkPopup] = useState(false);
  const [remarkValue, setRemarkValue] = useState("");
  const [remarkMeta, setRemarkMeta] = useState(null);
  const hideTimeoutRef = useRef(null);
  const [ffPlantCode, setFfPlantCode] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const fetchMergedCharges = async () => {
    try {
      setIsLoadingMergedCharges(true);

      const groupedPayload = {};

      allCategories.forEach((category, categoryIndex) => {
        const jobId = category.job_id || category.id;

        if (!groupedPayload[jobId]) {
          groupedPayload[jobId] = {
            id: jobId,
            project_id: projectId,
            job_type_id: category.rows[0]?.jobTypeId || null,
            job_created_date:
              category.job_created_date ??
              category.rows?.[0]?.job_created_date,
            job_line: []
          };
        }

        category.rows.forEach((row, rowIndex) => {
          if (!row.isChecked) return;

          const attachmentKey = `${categoryIndex}_${rowIndex}`;
          const chargeId = selectedChargeIds[attachmentKey];
          if (!chargeId) return;

          groupedPayload[jobId].job_line.push({
            job_line_id: row.jobLineId || null,
            project_id: projectId,
            job_type_id: category.rows[0]?.jobTypeId || null,
            charge_id: chargeId,
            description_of_charges: row.description || "",
            accrual: Number(row.salesAccrual) || 0,
            remarks: row.salesRemarks || "",
            contract_value: Number(row.salesContractValue) || 0,
            unit_of_quantity: Number(row.salesunitQuantity) || 0,
            unit_of_rate: Number(row.salesRate) || 0,
            net_total: Number(row.salesNetTotal) || 0,
            po_wo_number: row.po_wo_number || null,
            po_wo_date: row.po_wo_date || null,
            existing_sales_attachment_url: row.existingAttachmentUrl || "",
            attachment_keys: { sales: attachmentKey }
          });
        });
      });

      const finalPayload = Object.values(groupedPayload).filter(
        job => job.job_line.length
      );

      if (!finalPayload.length) {
        toast.warning("No charges selected for merging");
        return;
      }

      const formData = new FormData();
      formData.append("jobs", JSON.stringify(finalPayload));

      allCategories.forEach((category, categoryIndex) => {
        category.rows.forEach((row, rowIndex) => {
          const key = `${categoryIndex}_${rowIndex}`;
          row.uploadedFiles?.forEach(file => {
            formData.append(`attachments[${key}][]`, file);
          });
        });
      });

      const response = await axiosInstance.post("/invoice/mergedcharges", formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (!response.data.success) {
        toast.error(response.data.message);
        return;
      }

      setMergedChargesData(response.data.data);

      setAllCategories(prevCategories => {
        const updated = [...prevCategories];

        response.data.data.forEach(group => {
          const jobId = group.job_id;

          group.rows.forEach(serverRow => {
            const serverChargeId = serverRow.charge_id;
            const serverJobLineId = serverRow.job_line_id;

            updated.forEach((category, categoryIndex) => {
              const catJobId = category.job_id || category.id;

              if (Number(catJobId) !== Number(jobId)) return;

              category.rows.forEach((row, rowIndex) => {
                const attachmentKey = `${categoryIndex}_${rowIndex}`;

                if (
                  selectedChargeIds[attachmentKey] === serverChargeId &&
                  (!row.jobLineId || row.jobLineId !== serverJobLineId)
                ) {
                  row.jobLineId = serverJobLineId;
                }
              });
            });
          });
        });

        return updated;
      });

      const jobMap = {};

      response.data.data.forEach(group => {
        const jobId = group.job_id;

        if (!jobMap[jobId]) {
          jobMap[jobId] = new Set();
        }

        group.rows.forEach(row => {
          if (row.job_line_id) {
            jobMap[jobId].add(row.job_line_id);
          }
        });
      });

      const sessionData = {
        jobs: Object.entries(jobMap).map(([job_id, lineSet]) => ({
          job_id: Number(job_id),
          job_line_ids: Array.from(lineSet)
        })),
      };

      sessionStorage.setItem("mergedChargesData", JSON.stringify(sessionData));
      handleOpenPopup();
      toast.success("Charges merged successfully!");

    } catch (error) {
      const backendMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Something went wrong while merging charges";
         toast.error(backendMessage);
    } finally {
      setIsLoadingMergedCharges(false);
    }
  };

  const regenerateInvoiceFromSession = async (jobsData) => {
    try {
      const payload = {
        jobs: jobsData.map(job => ({
          job_id: job.job_id,
          job_line_ids: job.job_line_ids
        }))
      };

      console.log("Regenerating invoice with payload:", payload);

      const response = await axiosInstance.post('/job/generate_multi_sales_line_invoice', payload);

      if (response.data.success) {
        return response.data;
      }
    } catch (error) {
      console.error("Error regenerating invoice:", error);
    }
  };

  const handleMergedCharges = () => {
    setShowMergeConfirm(true);
    setConfirmAction(() => fetchMergedCharges);
  };

  const handleConfirmAction = () => {
    if (confirmAction) {
      confirmAction();
    }
    setShowMergeConfirm(false);
    setConfirmAction(null);
  };

  const handleSeparateInvoice = async () => {
    try {
      setIsLoadingSeparateCharges(true);

      const selectedLineItems = [];

      allCategories.forEach((category, categoryIndex) => {
        category.rows.forEach((row, rowIndex) => {
          if (row.isChecked === false) return;

          const attachmentKey = `${categoryIndex}_${rowIndex}`;
          const jobId = category.job_id || category.id;

          selectedLineItems.push({
            job_id: jobId,
            job_type_id: row.jobTypeId,
            job_sales_line_id: row.jobLineId || null,
            charge_id: selectedChargeIds[attachmentKey] || 0,
            description: row.description || "",
            sales_unit_of_quantity: Number(row.salesunitQuantity) || 0,
            sales_unit_of_rate: Number(row.salesRate) || 0,
            sales_net_total: Number(row.salesNetTotal) || 0,
            sales_remarks: row.salesRemarks || "",
            sales_accrual: Number(row.salesAccrual) || 0,
            sales_contract_value: Number(row.salesContractValue) || 0,
            po_wo_number: row.po_wo_number || null,
            po_wo_date: row.po_wo_date || null,
            existing_sales_attachment_url: row.existingAttachmentUrl || "",
            job_created_date: category.job_created_date,
            attachment_keys: { sales: attachmentKey },
            uploadedFiles: row.uploadedFiles || []
          });
        });
      });

      if (!selectedLineItems.length) {
        toast.warning("Please select at least one line item");
        return;
      }

      const jobsGrouped = {};

      selectedLineItems.forEach(item => {
        if (!jobsGrouped[item.job_id]) {
          jobsGrouped[item.job_id] = {
            id: item.job_id,
            project_id: projectId,
            job_type_id: item.job_type_id,
            job_created_date: item.job_created_date,
            ff_plant_id: ffPlantCode,
            job_line: []
          };
        }

        jobsGrouped[item.job_id].job_line.push({
          job_line_id: item.job_sales_line_id,
          project_id: projectId,
          job_type_id: item.job_type_id,
          charge_id: item.charge_id,
          description_of_charges: item.description,
          accrual: item.sales_accrual,
          remarks: item.sales_remarks,
          contract_value: item.sales_contract_value,
          unit_of_quantity: item.sales_unit_of_quantity,
          unit_of_rate: item.sales_unit_of_rate,
          net_total: item.sales_net_total,
          po_wo_number: item.po_wo_number,
          po_wo_date: item.po_wo_date,
          existing_sales_attachment_url: item.existing_sales_attachment_url,
          attachment_keys: item.attachment_keys
        });
      });

      const jobsPayload = Object.values(jobsGrouped);
      console.log("Separate Invoice Payload:", jobsPayload);

      const formData = new FormData();
      formData.append("jobs", JSON.stringify(jobsPayload));

      allCategories.forEach((category, categoryIndex) => {
        category.rows.forEach((row, rowIndex) => {
          if (!row.isChecked) return;
          row.uploadedFiles?.forEach(file => {
            formData.append(`attachments[${categoryIndex}_${rowIndex}][]`, file);
          });
        });
      });

      const response = await axiosInstance.post(
        "/invoice/selected_separate_charges",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (!response.data.success) {
        toast.error(response.data.message || "Separate invoice failed");
        return;
      }

      const separateCharges = response.data.data?.original?.line_items || [];

      const syncJobLineIdsToUI = (separateCharges) => {
        setAllCategories(prevCategories => {
          const updated = [...prevCategories];

          separateCharges.forEach(job => {
            job.details.forEach(serverRow => {
              const serverJobId = serverRow.job_id;
              const serverChargeId = serverRow.charge_id;
              const serverJobLineId = serverRow.job_sales_line_id;

              updated.forEach((category, categoryIndex) => {
                const catJobId = category.job_id || category.id;
                if (Number(catJobId) !== Number(serverJobId)) return;

                category.rows.forEach((row, rowIndex) => {
                  const attachmentKey = `${categoryIndex}_${rowIndex}`;

                  if (
                    selectedChargeIds[attachmentKey] === serverChargeId &&
                    (!row.jobLineId || row.jobLineId !== serverJobLineId)
                  ) {
                    row.jobLineId = serverJobLineId;
                  }
                });
              });
            });
          });

          return updated;
        });
      };

      setSeparateChargesData(separateCharges);
      syncJobLineIdsToUI(separateCharges);

      const jobMap = {};

      separateCharges.forEach((job) => {
        if (job.details && Array.isArray(job.details) && job.details.length > 0) {
          const jobId = job.details[0]?.job_id;

          if (jobId) {
            if (!jobMap[jobId]) {
              jobMap[jobId] = new Set();
            }

            job.details.forEach(detail => {
              if (detail.job_sales_line_id) {
                jobMap[jobId].add(detail.job_sales_line_id);
              }
            });
          }
        }
      });

      const sessionData = {
        jobs: Object.entries(jobMap).map(([job_id, lineSet]) => ({
          job_id: Number(job_id),
          job_line_ids: Array.from(lineSet)
        })),
        invoice_type: "separate"
      };

      sessionStorage.setItem("separateChargesData", JSON.stringify(sessionData));

      console.log("Separate charges session data stored:", sessionData);


      setIsSeparateInvoicePopupOpen({
        open: true,
        backdatedDays:
          parseInt(
            response.data.data?.original?.summary?.[0]?.backdated_days
          ) || 0
      });

      toast.success("Separate invoice generated successfully!");
    } catch (error) {
      console.error("❌ Separate Invoice Error:", error);
      toast.error(
        error.response?.data?.message ||
        "Error creating separate invoice"
      );
    } finally {
      setIsLoadingSeparateCharges(false);
    }
  };

  const handleOpenPopup = () => setIsMergedListPopupOpen(true);
  const handleClosePopup = () => setIsMergedListPopupOpen(false);

  const calculateCategoryTotals = (category) => {
    const totals = {
      salesAccrual: 0,
      salesNetTotal: 0
    };

    category.rows.forEach(row => {
      totals.salesAccrual += parseFloat(row.salesAccrual) || 0;
      totals.salesNetTotal += parseFloat(row.salesNetTotal) || 0;
    });

    return totals;
  };

  const getMinBackdatedDate = (currentDate, days) => {
    const minDate = new Date(currentDate);
    minDate.setDate(minDate.getDate() - days);
    return minDate;
  };

  const location = useLocation();

  useEffect(() => {
    if (isMergedListPopupOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isMergedListPopupOpen]);

  useEffect(() => {
    if (isSeparateInvoicePopupOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isSeparateInvoicePopupOpen]);


  useEffect(() => {
    const initializeBillData = async () => {
      if (location.state?.billData) {
        let billData;

        const separateSessionData = sessionStorage.getItem('separateChargesData');
        const mergedSessionData = sessionStorage.getItem('mergedChargesData');

        if (separateSessionData) {
          try {
            const parsedData = JSON.parse(separateSessionData);
            console.log("Separate invoice session data found:", parsedData);

            if (parsedData.jobs && Array.isArray(parsedData.jobs)) {
              const freshBillData = await regenerateInvoiceFromSession(parsedData.jobs);

              if (freshBillData) {
                billData = freshBillData;
                console.log("Successfully regenerated separate invoice from session");
              } else {
                console.log("Failed to regenerate separate invoice, using location state");
                billData = location.state.billData;
              }
            } else {
              console.log("Invalid separate session structure, using location state");
              billData = location.state.billData;
            }
          } catch (error) {
            console.error("Separate session data error:", error);
            billData = location.state.billData;
          }
        } else if (mergedSessionData) {
          try {
            const parsedData = JSON.parse(mergedSessionData);
            console.log("Merged charges session data found:", parsedData);

            if (parsedData.jobs && Array.isArray(parsedData.jobs)) {
              const freshBillData = await regenerateInvoiceFromSession(parsedData.jobs);

              if (freshBillData) {
                billData = freshBillData;
                console.log("Successfully regenerated merged invoice from session");
              } else {
                console.log("Failed to regenerate merged invoice, using location state");
                billData = location.state.billData;
              }
            } else {
              console.log("Invalid merged session structure, using location state");
              billData = location.state.billData;
            }
          } catch (error) {
            console.error("Merged session data error:", error);
            billData = location.state.billData;
          }
        } else {
          console.log("No session data, using location state");
          billData = location.state.billData;
        }

        const selected_job_id = location.state.selectedBills;
        setSelectedJobId(selected_job_id);
        setInitialSelectedJobs(billData.line_items);
        setSummary(billData.summary);

        if (billData.summary?.[0]?.backdated_days) {
          setBackdatedDays(parseInt(billData.summary[0].backdated_days));
        }

        if (billData.backdated_date) {
          setBackdatedDate(new Date(billData.backdated_date));
        }

        setLineitems(billData.line_items);
        setselectedprojectId(billData.summary[0]?.project_id);
        setFfPlantCode(billData.line_items?.[0]?.ff_plant_id || null);
        if (billData.line_items?.[0]?.supply_period) {
          const period = billData.line_items[0].supply_period;
          const [month, year] = period.split("-");
          const date = new Date(`${month} 1, ${year}`);
          setSupplyPeriod(date);
        }
        setSelectedChargeIds(() => {
          const idMap = {};
          billData.line_items.forEach((item, i) => {
            item.details.forEach((detail, j) => {
              idMap[`${i}_${j}`] = detail.charge_id;
            });
          });
          return idMap;
        });

        setProjectName(billData.summary?.[0]?.project_name || "");
      }
    };

    initializeBillData();
  }, [location.state]);

  useEffect(() => {
    if (lineitems.length > 0) {
      const categories = lineitems.map(job => {
        console.log(
          `Job No: ${job.job_no} | contract_id: ${job.contract_id}`
        );
        const rows = job.details.map(detail => ({
          billingtype: "",
          elements: "",
          salesRemarks: detail.sales_remarks,
          chargecode: detail.charge_code,
          jobIds: detail.job_id,
          jobTypeId: detail.job_type_id,
          jobLineId: detail.job_sales_line_id,
          division_type: detail.job_type_division,
          description: detail.description,
          // unitQuantity: detail.unit_of_quantity,
          po_wo_number: detail.sales_po_wo_number || null,
          po_wo_date: detail.sales_po_wo_date || null,
          salesunitQuantity: detail.sales_unit_of_quantity,
          salesRate: detail.sales_unit_of_rate, // From response
          salesNetTotal: detail.sales_net_total, // From response
          salesAccrual: detail.sales_accrual, // From response  

          salesContractValue: detail.sales_contract_value,

          // accrualSplit: detail.accrual,
          attachment: detail.attachment_url || "",
          existingAttachmentUrl: detail.attachment_url || "",
          uploadedFiles: [],
          isChecked: true,
          supporting_document: detail.sales_supporting_doc ?? false,
        }));
        const totals = calculateCategoryTotals({ rows });
        return {
          id: job.job_no,
          job_id: job.details[0]?.job_id || null,
          // accrual: Number(job.accrual).toFixed(2),
          salesAccrual: totals.salesAccrual,
          salesNetTotal: totals.salesNetTotal,
          contract_id: job.contract_id,
          name: `Job Number-${job.job_no}`,
          jobNo: job.job_no,
          rate: 1000,
          rows: rows,
          isChecked: true,
          job_created_date: job.job_created_date
        };
      });

      console.log("categories initial check from api", categories);


      setAllCategories(categories);

      //  Populate inputValues here
      const initialInputValues = {};
      categories.forEach((category, catIndex) => {
        initialInputValues[catIndex] = {};
        category.rows.forEach((row, rowIndex) => {
          initialInputValues[catIndex][rowIndex] = row.chargecode || "";
        });
      });
      setInputValues(initialInputValues);
    }
  }, [lineitems]);


  // When selected jobs change, update the categories
  useEffect(() => {
    // Create categories directly from the selectedJobs in state
    const newCategories = selectedJobs.map(jobId => {
      // Find the job in the initial selected jobs from location state
      const job = initialSelectedJobs.find(j => j.jobNo === jobId);
      console.log('mohannnnnnnnnnn', job);

      return {
        id: job?.jobNo || jobId,
        jobId: job?.job_id || 0,
        name: `Job-${job?.jobNo || jobId}`,
        // quantity: job ? parseInt(job.projectCost.replace(/\D/g, '')) / 1000 || 0 : 0,
        rate: 1000, // Default rate or calculate as needed
        // netValue: job ? parseInt(job.projectCost.replace(/\D/g, '')) || 0 : 0,
        rows: [{
          billingtype: "",
          jobTypeId: "",
          jobLineId: "",
          chargecode: "",
          elements: "",
          remarks: "",
          description: job?.project || "",
          po_wo_number: null,
          po_wo_date: null,
          // unitQuantity: "",
          salesunitQuantity: "",
          salesRemarks: "",
          salesRate: "",
          salesNetTotal: "",
          salesAccrual: "",
          salesContractValue: "0.00",
          attachment: "",
          existingAttachmentUrl: job?.attachment_url || "",
          uploadedFiles: [],
          isChecked: true,
          contract_id: null,
          job_created_date: job.job_created_date
        }]
      };
    });

    setAllCategories(newCategories);
  }, [selectedJobs]);

  // const handleJobSelection = (e) => {
  //   const selectedOptions = Array.from(e.target.selectedOptions).map(option => option.value);
  //   setSelectedJobs(selectedOptions);
  // };

  // const handleRemoveJob = (jobIdToRemove) => {
  //   setSelectedJobs(prev => prev.filter(jobId => jobId !== jobIdToRemove));

  //   // Also remove categories associated with this job
  //   setAllCategories(prev => {
  //     const jobToRemove = jobData.find(j => j.id === jobIdToRemove);
  //     if (!jobToRemove) return prev;

  //     const categoryIdsToRemove = jobToRemove.categories.map(c => c.id);
  //     return prev.filter(cat => !categoryIdsToRemove.includes(cat.id));
  //   });
  // };



  // const handleRemoveJob = async (jobIdToRemove) => {
  //   const confirmed = window.confirm("Are you sure you want to remove this job?");
  //   if (!confirmed) return;

  //   console.log("Existing job id", selectedJobId);
  //   console.log("Trying to remove:", jobIdToRemove);

  //   const updatedJobs = selectedJobId.filter(jobId => Number(jobId) !== Number(jobIdToRemove));
  //   console.log("After removed job id", updatedJobs);

  //   setSelectedJobs(updatedJobs);

  //   try {
  //     const invoicePayload = { job_ids: updatedJobs };
  //     const invoiceResponse = await axiosInstance.post('/job/generate_invoice', invoicePayload);

  //     if (invoiceResponse.data.success) {
  //       navigate("/invoice_addNew", {
  //         state: {
  //           billData: invoiceResponse.data,
  //           selectedJobs: updatedJobs
  //         }
  //       });
  //     } else {
  //       toast.error("Failed to regenerate invoice data");
  //     }
  //   } catch (error) {
  //     console.error("Error regenerating invoice:", error);
  //     toast.error(error.response?.data?.message || "Invoice regeneration failed");
  //   }
  // };





  const handleAttachFileUpload = (e) => {
    const files = Array.from(e.target.files);
    setUploadedFiles([...uploadedFiles, ...files]);
  };

  const handleAttachRemoveFile = (index) => {
    const newFiles = [...uploadedFiles];
    newFiles.splice(index, 1);
    setUploadedFiles(newFiles);
  };

  const addRow = (categoryId) => {
    setAllCategories(prevCategories =>
      prevCategories.map(category =>
        category.id === categoryId
          ? {
            ...category,
            rows: [
              ...category.rows,
              {
                billingtype: "",
                jobTypeId: category.rows[0]?.jobTypeId || "",
                jobIds: category.job_id || null,
                chargecode: "",
                elements: "",
                description: "",
                salesunitQuantity: "",
                salesRemarks: "",
                salesRate: "",
                salesNetTotal: "",
                salesContractValue: "0.00",
                po_wo_number: null,
                po_wo_date: null,
                salesAccrual: "",
                attachment: "",
                uploadedFiles: [],
                isChecked: true,
                contract_id: null,
              },
            ],
          }
          : category
      )
    );
  };

  const handleFileUpload = (e, categoryId, index, lineindex) => {
    const files = validateAttachments(e.target.files);
    if (!files.length) return;

    setAllCategories(prevCategories =>
      prevCategories.map(category =>
        category.id === categoryId
          ? {
            ...category,
            rows: category.rows.map((row, i) =>
              i === lineindex ? { ...row, uploadedFiles: [...(row.uploadedFiles || []), ...files] } : row
            ),
          }
          : category
      )
    );
  };

  const handleRemoveFile = (categoryId, index, lineindex, fileIndex) => {
    setAllCategories(prevCategories =>
      prevCategories.map(category =>
        category.id === categoryId
          ? {
            ...category,
            rows: category.rows.map((row, i) =>
              i === lineindex
                ? {
                  ...row,
                  uploadedFiles: row.uploadedFiles.filter((_, index) => index !== fileIndex),
                }
                : row
            ),
          }
          : category
      )
    );
  };

  // const handleInputChange = (e, index, rowIndex, field) => {
  //   const { value } = e.target;

  //   setAllCategories(prevCategories =>
  //     prevCategories.map((category, currentindex) =>
  //       currentindex === index
  //         ? {
  //           ...category,
  //           rows: category.rows.map((row, i) => {
  //             if (i === rowIndex) {
  //               const updatedRow = { ...row, [field]: value };

  //               if (field === 'unitQuantity' || field === 'unitRatePrice') {
  //                 const quantity = parseFloat(updatedRow.unitQuantity) || 0;
  //                 const rate = parseFloat(updatedRow.unitRatePrice) || 0;
  //                 updatedRow.netTotal = (quantity * rate).toString();
  //               }

  //               return updatedRow;
  //             }
  //             return row;
  //           }),
  //         }
  //         : category
  //     )
  //   );
  // };


  // const handleInputChange = (e, categoryId, rowIndex, field) => {
  //   const { value } = e.target;

  //   setAllCategories(prevCategories =>
  //     prevCategories.map(category =>
  //       category.id === categoryId
  //         ? {
  //           ...category,
  //           rows: category.rows.map((row, i) => {
  //             if (i === rowIndex) {
  //               const updatedRow = { ...row, [field]: value };

  //               if (field === 'unitQuantity' || field === 'unitRatePrice') {
  //                 const quantity = parseFloat(updatedRow.unitQuantity) || 0;
  //                 const rate = parseFloat(updatedRow.unitRatePrice) || 0;
  //                 updatedRow.netTotal = (quantity * rate).toString();
  //               }

  //               return updatedRow;
  //             }
  //             return row;
  //           }),
  //         }
  //         : category
  //     )
  //   );
  // };


  const handleInputChange = (e, index, rowIndex, field) => {
    let value = e.target.value;

    if (field === "salesRemarks") {
      value = value.replace(/,/g, "");
    }

    setAllCategories(prevCategories =>
      prevCategories.map((category, currentindex) => {
        if (currentindex === index) {
          const updatedRows = category.rows.map((row, i) => {
            if (i === rowIndex) {
              const updatedRow = { ...row, [field]: value };

              // Recalculate values when relevant fields change
              if (field === 'salesunitQuantity' || field === 'salesRate') {
                const Salesquantity = parseFloat(updatedRow.salesunitQuantity) || 0;
                const salesRate = parseFloat(updatedRow.salesRate) || 0;
                updatedRow.salesNetTotal = (Salesquantity * salesRate).toFixed(2);
              }

              if (field === 'costunitQuantity' || field === 'costRate') {
                const Costquantity = parseFloat(updatedRow.costunitQuantity) || 0;
                const costRate = parseFloat(updatedRow.costRate) || 0;
                updatedRow.costNetTotal = (Costquantity * costRate).toFixed(2);
              }

              // Calculate profit whenever sales or cost changes
              if (field === 'salesRate' || field === 'costRate' ||
                field === 'salesunitQuantity' || field === 'salesNetTotal' ||
                field === 'costNetTotal') {
                const salesTotal = parseFloat(updatedRow.salesNetTotal) || 0;
                const costTotal = parseFloat(updatedRow.costNetTotal) || 0;
                updatedRow.profitAmount = (salesTotal - costTotal).toFixed(2);
                updatedRow.profitPercent = costTotal > 0
                  ? (((salesTotal - costTotal) / costTotal) * 100).toFixed(2)
                  : '0.00';
              }

              return updatedRow;
            }
            return row;
          });

          // Calculate category totals
          const categoryTotals = updatedRows.reduce((acc, row) => {
            return {
              salesNetTotal: acc.salesNetTotal + (parseFloat(row.salesNetTotal) || 0),
              costNetTotal: acc.costNetTotal + (parseFloat(row.costNetTotal) || 0),
              profitAmount: acc.profitAmount + (parseFloat(row.profitAmount) || 0)
            };
          }, { salesNetTotal: 0, costNetTotal: 0, profitAmount: 0 });

          const profitPercent = categoryTotals.costNetTotal > 0
            ? ((categoryTotals.profitAmount / categoryTotals.costNetTotal) * 100).toFixed(2)
            : '0.00';

          return {
            ...category,
            rows: updatedRows,
            salesNetTotal: categoryTotals.salesNetTotal.toFixed(2),
            costNetTotal: categoryTotals.costNetTotal.toFixed(2),
            profitAmount: categoryTotals.profitAmount.toFixed(2),
            profitPercent
          };
        }
        return category;
      })
    );
  };

  const handleCheckboxChange = (e, categoryId, rowIndex) => {
    const isChecked = e.target.checked;

    setAllCategories(prevCategories => {
      const updatedCategories = prevCategories.map(category => {
        if (category.id === categoryId) {
          const updatedRows = category.rows.map((row, i) =>
            i === rowIndex ? { ...row, isChecked } : row
          );

          // Check if all line items are checked
          const allRowsChecked = updatedRows.every(row => row.isChecked);

          return {
            ...category,
            rows: updatedRows,
            isChecked: allRowsChecked
          };
        }
        return category;
      });

      // Check if all jobs are checked to update "Select All"
      const allJobsChecked = updatedCategories.every(cat => cat.isChecked);
      if (document.getElementById('selectAll')) {
        document.getElementById('selectAll').checked = allJobsChecked;
      }

      return updatedCategories;
    });
  };

  // const deleteRow = (categoryId, rowIndex) => {
  //   setAllCategories(prevCategories =>
  //     prevCategories.map(category => {
  //       if (category.id === categoryId) {
  //         const newRows = [...category.rows];
  //         newRows.splice(rowIndex, 1);
  //         return { ...category, rows: newRows };
  //       }
  //       return category;
  //     })
  //   );
  // };



  const deleteRow = (categoryId, rowIndex) => {
    const categoryIndex = allCategories.findIndex(cat => cat.id === categoryId);

    if (categoryIndex === -1) {
      return; // Category not found, should not happen but good to check
    }

    const category = allCategories[categoryIndex];

    if (category.rows.length <= 1) {
      toast.error("At least one row must remain, cannot delete.");
      return;
    }

    setAllCategories(prevCategories =>
      prevCategories.map(cat => {
        if (cat.id === categoryId) {
          const newRows = [...cat.rows];
          newRows.splice(rowIndex, 1);
          return { ...cat, rows: newRows };
        }
        return cat;
      })
    );

    setInputValues(prevInputValues => {
      const newInputValues = { ...prevInputValues };
      if (newInputValues[categoryIndex]) {
        const rows = { ...newInputValues[categoryIndex] };
        delete rows[rowIndex];
        const shiftedRows = {};
        Object.keys(rows).forEach(key => {
          const keyNum = Number(key);
          shiftedRows[keyNum > rowIndex ? keyNum - 1 : keyNum] = rows[key];
        });
        newInputValues[categoryIndex] = shiftedRows;
      }
      return newInputValues;
    });

    setSelectedChargeIds(prevSelectedChargeIds => {
      const newSelectedChargeIds = {};
      Object.keys(prevSelectedChargeIds).forEach(key => {
        const [catIndexStr, rowIdxStr] = key.split('_');
        const catIndex = Number(catIndexStr);
        const rowIdx = Number(rowIdxStr);

        if (catIndex === categoryIndex) {
          if (rowIdx < rowIndex) {
            newSelectedChargeIds[key] = prevSelectedChargeIds[key];
          } else if (rowIdx > rowIndex) {
            newSelectedChargeIds[`${catIndex}_${rowIdx - 1}`] = prevSelectedChargeIds[key];
          }
          // If rowIdx === rowIndex, we simply skip it (the deleted row)
        } else {
          newSelectedChargeIds[key] = prevSelectedChargeIds[key];
        }
      });
      return newSelectedChargeIds;
    });

    setSuggestionsMap(prev => {
      const newMap = { ...prev };
      if (newMap[categoryIndex]) {
        const rows = { ...newMap[categoryIndex] };
        delete rows[rowIndex];
        const shiftedRows = {};
        Object.keys(rows).forEach(key => {
          const keyNum = Number(key);
          shiftedRows[keyNum > rowIndex ? keyNum - 1 : keyNum] = rows[key];
        });
        newMap[categoryIndex] = shiftedRows;
      }
      return newMap;
    });
  };


  const toggleJobDropdown = () => {
    setIsJobDropdownOpen(!isJobDropdownOpen);
  };

  const handleJobCheckboxChange = (categoryId, isChecked) => {
    setAllCategories(prevCategories =>
      prevCategories.map(category =>
        category.id === categoryId
          ? {
            ...category,
            isChecked,
            rows: category.rows.map(row => ({
              ...row,
              isChecked
            }))
          }
          : category
      )
    );
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsJobDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  const handleSubmit = async (actionType) => {
    if (isSaving || isSubmitting) return;
    if (!validateSalesRows()) {
      return;
    }

    if (actionType === "save") {
      setIsSaving(true);
    } else {
      setIsSubmitting(true);
    }

    try {
      const generateInvoiceValue = allCategories.length > 0 ? "1" : "0";

      const jobs = allCategories
        .map((category, categoryIndex) => {
          const checkedRows = category.rows.reduce((acc, row, originalRowIndex) => {
            if (row.isChecked !== false) {
              const attachmentKey = `${categoryIndex}_${originalRowIndex}`;
              const hasNewFile = row.uploadedFiles?.length > 0;
              const typedChargeCode = inputValues?.[categoryIndex]?.[originalRowIndex]?.trim();

              const isRowUsed =
                typedChargeCode ||
                row.description ||
                row.salesunitQuantity ||
                row.salesRate

              if (!isRowUsed) return acc;

              acc.push({
                project_id: parseInt(projectId) || 0,
                job_type_id: row.jobTypeId,
                job_line_id: row.jobLineId,
                charge_id: selectedChargeIds[attachmentKey] || 0,
                description_of_charges: row.description || "",
                po_wo_number: row.po_wo_number || null,
                po_wo_date: row.po_wo_date || null,
                unit_of_quantity: parseFloat(row.salesunitQuantity) || 0,
                accrual: parseFloat(row.salesAccrual) || 0,
                remarks: row.salesRemarks || "",
                unit_of_rate: parseFloat(row.salesRate) || 0,
                net_total: parseFloat(row.salesNetTotal) || 0,
                contract_value: parseFloat(row.salesContractValue) || 0,
                attachment_keys: {
                  sales: attachmentKey,
                },
                ...(hasNewFile
                  ? {}
                  : row.existingAttachmentUrl && {
                    existing_sales_attachment_url: row.existingAttachmentUrl,
                  }),
              });
            }
            return acc;
          }, []);

          if (checkedRows.length === 0) return null;

          return {
            id: category.rows[0]?.jobIds || category.job_id || 0,
            jobnumber: category.jobNo || "",
            project_id: parseInt(projectId) || 0,
            job_type_id: category.rows[0]?.jobTypeId || 0,
            job_created_date: new Date().toISOString().split("T")[0],
            ff_plant_id: ffPlantCode,
            job_line: checkedRows,

          };
        })
        .filter(job => job !== null);

      const divisionType = allCategories?.[0]?.rows?.[0]?.division_type?.toLowerCase() || null;

      const payload = {
        jobs,
        actions: [actionType],
        invoice_target: 'sales',
        invoice_mode: 'combine',
        generate_invoice: generateInvoiceValue,
        sales_header_remarks: salesHeaderRemarks,
        supply_period: supplyPeriod
          ? supplyPeriod.toLocaleString("en-US", { month: "short" }) +
          "-" +
          supplyPeriod.getFullYear()
          : null,
        billing_nature: billingNature || null,
        backdated_date: backdatedDate
          ? `${backdatedDate.getFullYear()}-${(backdatedDate.getMonth() + 1)
            .toString()
            .padStart(2, '0')}-${backdatedDate.getDate().toString().padStart(2, '0')}`
          : null,
        division_type: divisionType,
      };

      const formData = new FormData();
      formData.append("data", JSON.stringify(payload));

      // Append only attachments from checked rows with correct attachmentKey
      allCategories.forEach((category, categoryIndex) => {
        category.rows.forEach((row, rowIndex) => {
          if (row.isChecked !== false && row.uploadedFiles?.length > 0) {
            row.uploadedFiles.forEach((file) => {
              const attachmentKey = `${categoryIndex}_${rowIndex}`;
              formData.append(`attachments[${attachmentKey}][]`, file);
            });
          }
        });
      });

      const response = await axiosInstance.post('/invoice/save', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      if (response.status === 200 && response.data.success === true) {
        toast.success(
          actionType === "submit"
            ? "Sales Invoice submitted successfully!"
            : "Sales Invoice saved successfully!"
        );
        navigate("/salesInvoice");
      } else if (response.data.success === false) {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error submitting invoice:", error);
      toast.error("Error while submitting: " + error.message);
    } finally {
      setIsSaving(false);
      setIsSubmitting(false);
    }
  };

  const calculateSummaryTotals = () => {
    return allCategories.reduce((acc, category) => {
      const categoryTotals = calculateCategoryTotals(category);
      return {
        quantity: acc.quantity + categoryTotals.quantity,
        rate: acc.rate + categoryTotals.rate,
        netValue: acc.netValue + categoryTotals.netValue
      };
    }, { quantity: 0, rate: 0, netValue: 0 });
  };

  const handleRemoveAttachment = (categoryId, index, lineindex) => {
    setAllCategories(prevCategories =>
      prevCategories.map(category =>
        category.id === categoryId
          ? {
            ...category,
            rows: category.rows.map((row, i) =>
              i === lineindex
                ? {
                  ...row,
                  attachment: "",
                  existingAttachmentUrl: "",
                  uploadedFiles: []
                }
                : row
            ),
          }
          : category
      )
    );
  };








  const fetchSuggestions = async (searchTerm = "", rowIndex, index) => {
    try {
      setSuggestionsMap([]);

      // const response = await axios.get(
      //   `https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/project_based/getchargecodes/${projectId}`,
      //   {
      //     params: {
      //       term: searchTerm
      //     }
      //   }
      // );

      const response = await axiosInstance.get(
        `/getnonprojectsaleschargecodes`,
        {
          params: {
            term: searchTerm
          }
        }
      );

      if (response.data?.chargecodes) {

        const newSuggestions = response.data?.chargecodes || [];
        setSuggestionsMap(prev => {
          const updated = { ...prev };
          if (!updated[index]) updated[index] = {}; // initialize if empty
          updated[index][rowIndex] = newSuggestions;
          console.log("Updated suggestionsMap:", updated);
          return updated;
        });

        setShowSuggestionsMap(prev => ({
          ...prev,
          [`${index}_${rowIndex}`]: true,
        }));
      }
    } catch (err) {
      console.error("Failed to fetch suggestions", err);

      setSuggestionsMap(prev => {
        const updated = { ...prev };
        if (!updated[index]) updated[index] = {};
        updated[index][rowIndex] = []; // clear only that one
        return updated;
      });

      setShowSuggestionsMap(prev => ({
        ...prev,
        [`${index}_${rowIndex}`]: false,
      }));
    }
  };

  const handleJobCreated = (jobData) => {
    // Debugging: Log the incoming data
    console.log('Received jobData:', jobData);

    // Validate incoming data
    if (!jobData) {
      console.error('No job data received');
      return;
    }

    // Create a new category for the job with proper fallbacks
    const newCategory = {
      id: jobData.jobid,
      name: `Job-${jobData.jobNo}`,     // Fallback if jobNo is missing
      jobNo: jobData.jobNo || '',                // Ensure jobNo exists
      rows: (jobData.rows || []).map(row => {
        // Debug each row's chargecode
        console.log('Processing row with chargecode:', row.chargecode);

        return {
          jobTypeId: jobData.job_type_id,
          chargecode: row.chargecode,
          description: row.description || "",
          unitQuantity: row.unitQuantity || "",
          unitRatePrice: row.unitRatePrice || "",
          netTotal: row.netTotal || "",
          accrualSplit: row.netTotal || "",
          attachment: row.attachment || "",
          uploadedFiles: [],
          isChecked: false
        };
      })
    };

    // Add to allCategories
    setAllCategories(prev => [...prev, newCategory]);

    // Calculate summary only if we have valid data
    if (jobData.jobNo && jobData.rows) {
      setSummary(prev => [...prev, {
        job_no: jobData.jobNo,
        quantity: jobData.rows.reduce((sum, row) => sum + (parseFloat(row.unitQuantity) || 0), 0),
        rate: jobData.rows.reduce((sum, row) => sum + (parseFloat(row.unitRatePrice) || 0), 0),
        net_value: jobData.rows.reduce((sum, row) => sum + (parseFloat(row.netTotal) || 0), 0)
      }]);
    } else {
      console.error('Missing required data for summary:', {
        hasJobNo: !!jobData.jobNo,
        hasRows: !!jobData.rows
      });
    }
  };

  const handleSelectAllJobs = (e) => {
    const isChecked = e.target.checked;

    // Update all job checkboxes
    setAllCategories(prevCategories =>
      prevCategories.map(category => ({
        ...category,
        isChecked, // Add this property to track job selection
        rows: category.rows.map(row => ({
          ...row,
          isChecked
        }))
      }))
    );
  };

  console.log("existinggggggggggggggggg", selectedJobId)
  console.log('selectedJobs', selectedJobs);

  const loadJobs = async (inputValue) => {
    try {
      const response = await axiosInstance.post('/job/add_sales_job', {
        project_id: Number(projectId),
        existing_job_id: selectedJobId || [],
        search: inputValue,
      });

      if (response.data.success && Array.isArray(response.data.jobnumber)) {
        return response.data.jobnumber.map(job => ({
          value: String(job.value),
          label: String(job.label),
        }));
      } else {
        return [];
      }
    } catch (error) {
      console.error("Error loading jobs:", error);
      return [];
    }
  };


  useEffect(() => {
    console.log("updated selectedJobIddddddddddddddddddddddd", selectedJobId);
  }, [selectedJobId]);



  const handleAddJobsAndRegenerate = async (newJobIds) => {
    // Merge existing and new IDs
    const allJobIds = Array.from(new Set([...selectedJobId, ...newJobIds]));

    if (allJobIds.length === 0) {
      toast.warning("Please select at least one job to generate the bill");
      return;
    }

    try {
      // Use only sales endpoint here (you said sales-only)
      const endpoint = "/job/generate_sales_invoice";

      const response = await axiosInstance.post(endpoint, {
        job_ids: allJobIds
      });

      if (response.data.success) {
        toast.success("Sales bill regenerated successfully!");

        // Now navigate to *this* page again with new billData and job IDs
        navigate("/salesBillPage", {
          state: {
            billData: response.data,
            selectedBills: allJobIds,
            billType: "sales"
          }
        });

        setShowAddPopup(false);  // Close the popup
      } else {
        toast.error(response.data.message || "Failed to regenerate sales bill");
      }
    } catch (error) {
      console.error("Error generating sales bill:", error);
      toast.error(error.response?.data?.message || "Failed to regenerate sales bill");
    }
  };



  const handleRemoveJob = async (jobIdToRemove) => {
    const confirmed = window.confirm("Are you sure you want to remove this job?");
    if (!confirmed) return;

    // Filter out the job to remove
    const updatedJobs = selectedJobId.filter(
      (jobId) => Number(jobId) !== Number(jobIdToRemove)
    );

    if (updatedJobs.length === 0) {
      toast.warning("At least one job is required to generate the bill");
      return;
    }

    setSelectedJobs(updatedJobs);

    try {
      // Use sales-only endpoint
      const endpoint = "/job/generate_sales_invoice";
      const response = await axiosInstance.post(endpoint, {
        job_ids: updatedJobs
      });

      if (response.data.success) {
        toast.success("Sales bill regenerated successfully!");

        // Navigate to sales bill page with new data
        navigate("/salesBillPage", {
          state: {
            billData: response.data,
            selectedBills: updatedJobs,
            billType: "sales"
          }
        });
      } else {
        toast.error(response.data.message || "Failed to regenerate sales bill");
      }
    } catch (error) {
      console.error("Error regenerating sales bill:", error);
      toast.error(error.response?.data?.message || "Failed to regenerate sales bill");
    }
  };

  const [showBackdateConfirm, setShowBackdateConfirm] = useState(false);
  const [allowBackdate, setAllowBackdate] = useState(false);
  const [backdatedDate, setBackdatedDate] = useState(null);
  const [shouldOpenCalendar, setShouldOpenCalendar] = useState(false);
  const datePickerRef = useRef();

  const handleBackClick = () => {
    sessionStorage.removeItem("mergedChargesData");
    sessionStorage.removeItem("separateChargesData");
    navigate(-1);
  };

  const handleShow = () => {
    clearTimeout(hideTimeoutRef.current);
    setSeparateChargesShow(false);
    setShow(true);
  };

  const handleHide = () => {
    hideTimeoutRef.current = setTimeout(() => {
      setShow(false);
    }, 180);
  };

  const handleSeparateShow = () => {
    clearTimeout(hideTimeoutRef.current);
    setShow(false);
    setSeparateChargesShow(true);
  };

  const handleSeparateHide = () => {
    hideTimeoutRef.current = setTimeout(() => {
      setSeparateChargesShow(false);
    }, 180);
  };

  const openRemarkPopup = (rowIndex, lineIndex, value) => {
    setRemarkMeta({ rowIndex, lineIndex });
    setRemarkValue(value || "");
    setShowRemarkPopup(true);
  };
  
  const handleSaveRemark = (updatedValue) => {
    if (!remarkMeta) return;

    const { rowIndex, lineIndex } = remarkMeta;

    handleInputChange(
      { target: { value: updatedValue } },
      rowIndex,
      lineIndex,
      "salesRemarks"
    );

    setShowRemarkPopup(false);
  };

  const validateSalesRows = () => {
    for (let categoryIndex = 0; categoryIndex < allCategories.length; categoryIndex++) {
      const category = allCategories[categoryIndex];

      for (let rowIndex = 0; rowIndex < category.rows.length; rowIndex++) {
        const row = category.rows[rowIndex];

        if (row.isChecked === false) continue;

        const attachmentKey = `${categoryIndex}_${rowIndex}`;
        const chargeId = selectedChargeIds[attachmentKey] ?? 0;
        const typedChargeCode =
          inputValues?.[categoryIndex]?.[rowIndex]?.trim();

        const isRowUsed =
          typedChargeCode ||
          row.description ||
          row.salesunitQuantity ||
          row.salesRate ||
          row.uploadedFiles?.length;

        if (!isRowUsed) continue;

        if (!typedChargeCode) {
          toast.error(`Charge Code is required - LineItem ${rowIndex + 1}`);
          return false;
        }
        if (chargeId === 0) {
          toast.error(
            `Please select a valid Charge Code from the list - LineItem ${rowIndex + 1}`
          );
          return false;
        }
        if (!row.description?.trim()) {
          toast.error(`Description is required - LineItem ${rowIndex + 1}`);
          return false;
        }
      }
    }

    return true;
  };

  return (
    <>
      <GenerateInvoiceHeader onSearch={null} disableSearch={true} />
      <div className="invoice_popup">
        <div className="invoice_popup_header">
          <div className="invoice_popup_header_left">
            <img src={back_arrow} alt="Back Arrow" onClick={handleBackClick}
              style={{ cursor: "pointer" }} />
            <p className="new_cost_line">Sales Invoice</p>
          </div>
          <div className="invoice_popup_header_right">
            <button className="cancel_btn" onClick={() => navigate("/jobs")}>Cancel</button>
            <button className="cancel_btn" onClick={() => handleSubmit("save")} disabled={isSaving || isSubmitting}>{isSaving ? "Saving..." : "Save"}</button>
            <button className="submit_btn" onClick={() => setIsModalOpen(true)} disabled={isSaving || isSubmitting}>Submit</button>
          </div>
        </div>

        {isModalOpen && (
          <div className="modal" onClick={() => setIsModalOpen(false)}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <h3>Remarks to Customer</h3>
              <SapCsvSafeInput
                as="textarea"
                value={salesHeaderRemarks}
                onChange={setSalesHeaderRemarks}
                maxLength={255}
                placeholder="Enter your Remarks..."
                style={{
                  width: "100%",
                  minHeight: "80px",
                  padding: "8px",
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                  fontSize: "14px",
                  fontFamily: "Work Sans",
                }}
              />
              <p style={{ fontSize: "12px", textAlign: "right", color: "#555" }}>
                {salesHeaderRemarks.length}/255
              </p>

              <div
                style={{
                  display: "flex",
                  gap: "12px",
                  flexWrap: "wrap",
                  marginTop: "5px",
                }}
              >
                {/* Billing Nature */}
                <div style={{ flex: "1 1 45%" }}>
                  <label
                    style={{
                      display: "block",
                      fontSize: "14px",
                      fontWeight: 600,
                      fontFamily: "Work Sans",
                      color: "#19324C",
                    }}
                  >
                    Billing Nature
                  </label>
                  <SapCsvSafeInput
                    value={billingNature}
                    onChange={setBillingNature}
                    maxLength={18}
                    placeholder="Enter Billing Nature"
                    style={{
                      width: "100%",
                      height: '33px',
                      padding: "6px 8px",
                      border: "1px solid #ccc",
                      borderRadius: "6px",
                      fontSize: "13px",
                      fontFamily: "Work Sans",
                      margin: '0px'
                    }}
                  />
                  <p style={{ fontSize: "11px", textAlign: "right", color: "#777" }}>
                    {billingNature?.length || 0}/18
                  </p>
                </div>

                {/* Supply Period */}
                <div style={{ flex: "1 1 45%" }}>
                  <label
                    style={{
                      fontSize: "14px",
                      fontWeight: 600,
                      fontFamily: "Work Sans",
                      color: "#19324C",
                    }}
                  >
                    Supply Period
                  </label>
                  <DatePicker
                    selected={supplyPeriod}
                    onChange={(date) => setSupplyPeriod(date)}
                    dateFormat="MMM-yyyy"
                    showMonthYearPicker
                    className="generate-sales-custom-datepicker-input"
                    placeholderText="Select month & year"
                    disabled
                  />
                </div>
              </div>


              <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', width: '100%' }}>
                <p style={{ margin: 0, fontSize: '14px', fontWeight: 600, fontFamily: 'Work Sans', color: '#19324C' }}>
                  Backdated date
                </p>
                <DatePicker
                  ref={datePickerRef}
                  selected={backdatedDate}
                  onChange={(date) => {
                    setBackdatedDate(date);
                  }}
                  onFocus={(e) => {
                    if (!allowBackdate) {
                      e.preventDefault();
                      setShowBackdateConfirm(true);
                      setShouldOpenCalendar(true);
                    }
                  }}
                  onCalendarOpen={() => {
                    if (!allowBackdate) {
                      datePickerRef.current.setOpen(false);
                    }
                  }}
                  dateFormat="yyyy-MM-dd"
                  className="custom-datepicker-input"
                  placeholderText="Select a backdated date"
                  minDate={getMinBackdatedDate(new Date(), backdatedDays)}
                  maxDate={new Date()}
                />

                {showBackdateConfirm && (
                  <div style={{ marginTop: '8px' }}>
                    <p style={{ margin: 0, fontSize: '13px', color: '#333' }}>
                      Are you sure you want to consider this as the Invoice Date?
                    </p>
                    <div style={{ display: 'flex', gap: '10px', marginTop: '7px' }}>
                      <button
                        onClick={() => {
                          setAllowBackdate(true);
                          // setShowBackdateConfirm(false);
                          setTimeout(() => {
                            if (datePickerRef.current && shouldOpenCalendar) {
                              datePickerRef.current.setOpen(true);
                            }
                            setShouldOpenCalendar(false);
                          }, 0);
                        }}
                        style={{ padding: '4px 12px', borderRadius: '6px', border: '1px solid #ccc', height: '30px', width: '50px', fontSize: '13px' }}
                      >
                        Yes
                      </button>
                      <button
                        onClick={() => {
                          setAllowBackdate(false);
                          setBackdatedDate(null);
                          // setShowBackdateConfirm(false);
                          setShouldOpenCalendar(false);
                        }}
                        style={{ padding: '4px 12px', borderRadius: '6px', border: '1px solid #ccc', height: '30px', width: '40px', fontSize: '13px' }}
                      >
                        No
                      </button>
                    </div>
                  </div>
                )}
              </div>

              <div className="modal-buttons">
                <button
                  onClick={() => {
                    setIsModalOpen(false);
                    setBackdatedDate(null);
                    setAllowBackdate(false);
                    setShouldOpenCalendar(false);
                    setShowBackdateConfirm(false);
                  }}
                >
                  Cancel
                </button>
                <button
                  onClick={() => {
                    setIsModalOpen(false);
                    handleSubmit("submit");
                  }}
                  disabled={isSubmitting || isSaving}
                >
                  {isSubmitting ? "Submitting..." : "Submit"}
                </button>
              </div>
            </div>
          </div>
        )}

        <div className="invoice_popup_project">
          <div className="invoice-popup-project-content">
            <p className="invoice-popup-project-project">Project</p>
            <p className="invoice-popup-project-project-name">{projectName}</p>
          </div>
          <div className="invoice-popup-project-summary">
            <p className="invoice-popup-summary-summary">Summary</p>
            <table className="invoice-popup-summary-table">
              <thead>
                <tr>
                  <th>Jobs</th>
                  <th>Supply Period</th>
                  <th>Quantity</th>
                  <th>Rate</th>
                  <th>Net Value</th>
                </tr>
              </thead>
              <tbody>
                {summary.map((job, index) => (
                  <tr key={index}>
                    <td>{job.job_no}</td>
                    <td>{job.supply_period}</td>
                    <td>{job.sales_unit_of_quantity}</td>
                    <td>{job.sales_unit_of_rate}</td>
                    <td>{job.sales_net_total}</td>
                  </tr>
                ))}
                <tr className="total-row">
                  <td colSpan="2">Total</td>
                  <td>
                    {summary.reduce((sum, job) => sum + parseFloat(job.sales_unit_of_quantity || 0), 0).toFixed(2)}
                  </td>
                  <td>
                    {summary.reduce((sum, job) => sum + parseFloat(job.sales_unit_of_rate || 0), 0).toFixed(2)}
                  </td>
                  <td>
                    {summary.reduce((sum, job) => sum + parseFloat(job.sales_net_total || 0), 0).toFixed(2)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="invoice_popup_categories">

          <div
            className="invoice-generate-job"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "10px 10px",
              gap: "10px",
            }}
          >
            <div className="sales-select-all-wrapper" style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
              <input
                type="checkbox"
                id="selectAll"
                onChange={handleSelectAllJobs}
                checked={allCategories.length > 0 && allCategories.every(cat => cat.isChecked !== false)}
                defaultChecked={true} // Add this to ensure initial checked state
              />
              <label htmlFor="selectAll" style={{ fontSize: '13px', fontWeight: '600', fontFamily: 'Work Sans', cursor: 'pointer', margin: '0px' }}>Select All Jobs</label>
            </div>

            <div style={{ display: "flex", gap: "10px" }}>
              <div className="merged-tooltip-wrapper">
                <button
                  className="consolidated-sap-btn merged-btn-with-icon"
                  onClick={handleSeparateInvoice}
                >
                  <FiInfo className="merged-info-icon" onMouseEnter={handleSeparateShow}
                    onMouseLeave={handleSeparateHide}
                    disabled={isLoadingSeparateCharges} />
                  {isLoadingSeparateCharges ? "Loading..." : "Separate Invoice"}
                </button>

                {separateChargesShow && (
                  <div className="merged-tooltip" onMouseEnter={handleSeparateShow}
                    onMouseLeave={handleSeparateHide}>
                    <SeparateChargesTooltip />
                  </div>
                )}
              </div>

              <div className="merged-tooltip-wrapper"
              >
                <button
                  className="consolidated-sap-btn merged-btn-with-icon"
                  onClick={handleMergedCharges}
                >
                  <FiInfo className="merged-info-icon" onMouseEnter={handleShow}
                    onMouseLeave={handleHide}
                    disabled={isLoadingMergedCharges} />

                  {isLoadingMergedCharges ? "Loading..." : "Merged Charges"}
                </button>

                {show && (
                  <div className="merged-tooltip"    onMouseEnter={handleShow}
      onMouseLeave={handleHide}>
                    <MergedChargesTooltip />
                  </div>
                )}
              </div>

              <AdditionalPermissionWrapper permissionKey="add_sales_jobs" moduleId={ModuleId}>
                <button className="invoice-generate-job-btn" onClick={async () => { setShowAddPopup(true); await loadJobs(); }}>
                  + Add Job
                </button>
              </AdditionalPermissionWrapper>

              {/* <button className="invoice-generate-job-btn" onClick={() => setShowPopup(true)}>
                Create Job
              </button> */}
            </div>
          </div>


          {showaddPopup && (
            <div className="invoice-add-creation-popup-overlay">
              <div className="invoice-add-creation-popup-container">
                <div className="invoice-add-creation-popup-header">
                  <h2>Add Job</h2>
                  <button
                    className="invoice-add-creation-close-button"
                    onClick={() => setShowAddPopup(false)}
                  >
                    ×
                  </button>
                </div>

                <form>
                  <div className="invoice-add-creation-popup-body">
                    <div className="invoice-add-creation-form-group">
                      <label htmlFor="project" className="labels">Project</label>
                      <input
                        type="text"
                        id="project"
                        value={projectName}
                        readOnly
                        style={{ margin: "0px", backgroundColor: '#E9F4FF' }}
                      />
                    </div>

                    <div className="invoice-add-creation-form-group">
                      <label className="name">Job Number</label>
                      <AsyncSelect
                        isMulti
                        value={selectedJobOptions}
                        inputValue={jobInputValue}
                        onInputChange={(value) => setJobInputValue(value)}
                        onChange={(selectedOptions) => {
                          const selected = selectedOptions || [];
                          setSelectedJobOptions(selected);
                          const jobIds = selected.map(opt => Number(opt.value));
                          setSelectedJobIds(jobIds);
                          setSelectedJobId(prev => Array.from(new Set([...prev, ...jobIds])));
                        }}

                        loadOptions={loadJobs}
                        placeholder="Search and select job(s)..."
                        cacheOptions
                        defaultOptions
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        menuPortalTarget={document.body}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            width: '100%',
                            height: '37px',
                            borderRadius: '12px',
                            fontSize: '13px',
                            fontFamily: 'Work Sans',
                            borderColor: state.isFocused ? '#0747A6' : '#D0D6DF',
                            boxShadow: state.isFocused ? '0 0 0 1px #0747A6' : 'none',
                          }),
                          valueContainer: (base) => ({
                            ...base,
                            maxHeight: '100%',
                            overflowY: 'auto',
                            overflowX: 'auto',
                            display: 'flex',
                            flexWrap: 'nowrap',
                          }),
                          container: (base) => ({
                            ...base,
                            width: '100%',
                          }),
                          menu: (base) => ({
                            ...base,
                            fontSize: '13px',
                            fontFamily: 'Work Sans',
                          }),
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 9999,
                          }),
                          multiValue: (base) => ({
                            ...base,
                            backgroundColor: '#E6F0FF',
                            borderRadius: '4px',
                            padding: '2px 6px',
                            margin: '1px',
                          }),
                          multiValueLabel: (base) => ({
                            ...base,
                            color: '#0747A6',
                            fontSize: '11px',
                            fontWeight: 500,
                          }),
                          multiValueRemove: (base) => ({
                            ...base,
                            color: '#0747A6',
                            ':hover': {
                              backgroundColor: '#0747A6',
                              color: 'white',
                            },
                          }),
                        }}
                        components={{
                          DropdownIndicator: null,
                          IndicatorSeparator: null,
                          Option: ({ ...props }) => (
                            <components.Option {...props}>
                              <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                <input
                                  type="checkbox"
                                  checked={props.isSelected}
                                  readOnly
                                  style={{ marginRight: 8 }}
                                />
                                {props.label}
                              </div>
                            </components.Option>
                          ),
                        }}
                      />
                    </div>

                  </div>
                  <div className="invoice-add-creation-popup-footer">
                    <button
                      type="button"
                      className="invoice-add-submit-button"
                      onClick={() => handleAddJobsAndRegenerate(selectedJobIds)}
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}

          {showPopup && (
            <CreateJobs
              onClose={() => setShowPopup(false)}
              onJobCreated={(jobData) => {
                handleJobCreated(jobData);
                setShowPopup(false);
              }}
              projectId={projectId}
              projectName={projectName}
              selectedJobId={selectedJobId}
            />
          )}

          {allCategories.map((category, index) => {
            // console.log("category data check", category),

            const isContract = category.contract_id !== null;
            const contractLabel = isContract ? "C" : "NC";
            console.log("contractLabellllllllll", contractLabel);
            const contractColor = isContract ? "#129990" : "#FFB22C";

            return (
              <div key={category.id} className="invoice_popup_outercategory">
                <div className="invoice_popup_category_header">
                  <div
                    className="category_name_left"
                    style={{
                      display: "flex",
                      alignItems: "center", // vertical center
                      justifyContent: "center", // horizontal center
                      gap: "8px", // spacing between text and image
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={category.isChecked !== false}
                      onChange={(e) => handleJobCheckboxChange(category.id, e.target.checked)}
                    />
                    <span className="category_name">Job No - {category.id}</span>
                    <span
                      style={{
                        backgroundColor: contractColor,
                        color: "#fff",
                        padding: "2px 6px",
                        borderRadius: "4px",
                        fontSize: "0.75rem",
                        fontWeight: "bold",
                      }}
                    >
                      {contractLabel}
                    </span>

                    <AdditionalPermissionWrapper permissionKey="remove_sales_jobs" moduleId={ModuleId}>
                      <img
                        src={delete_icon}
                        style={{ width: '25px', height: '25px', cursor: 'pointer' }}
                        alt="Delete"
                        onClick={() => handleRemoveJob(category.job_id)}
                      />
                    </AdditionalPermissionWrapper>

                  </div>
                  <div style={{
                    display: "flex",
                    gap: "10px",
                    fontSize: "11px",
                    alignItems: "center",
                    overflowX: "auto",
                  }}>
                    {/* ACCRUAL BOX */}
                    <div style={{
                      backgroundColor: "#ffffff",
                      borderRadius: "8px",
                      padding: "6px 12px",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      height: "30px",
                      whiteSpace: "nowrap",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                    }}>
                      <span style={{ color: "#C89C00", fontWeight: 600 }}>ACCRUAL:</span>
                      <span style={{ color: "#000" }}>₹ {category.salesAccrual?.toLocaleString()}</span>
                    </div>

                    <div style={{
                      width: "1px",
                      backgroundColor: "#ccc",
                      alignSelf: "stretch"
                    }} />

                    <div style={{
                      backgroundColor: "#ffffff",
                      borderRadius: "8px",
                      padding: "6px 12px",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      height: "30px",
                      whiteSpace: "nowrap",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                    }}>
                      <span style={{ color: "green", fontWeight: 600 }}>SALES:</span>
                      <span style={{ color: "#000" }}>
                        Net Total : ₹ {category.salesNetTotal?.toLocaleString()}
                      </span>
                      {(() => {
                        const salesnetTotal = parseFloat(category.salesNetTotal) || 0;
                        const salesaccrual = parseFloat(category.salesAccrual) || 0;
                        const difference = salesnetTotal - salesaccrual;
                        const isPositive = difference >= 0;

                        return (
                          <span style={{
                            fontWeight: 600,
                            color: isPositive ? "green" : "red"
                          }}>
                            ({isPositive ? "+" : ""}{difference.toFixed(2)})
                          </span>
                        );
                      })()}
                    </div>
                  </div>
                </div>

                <div className="invoice_popup_category_subheader">
                  <div className="invoice_popup_element_list" style={{ overflowX: "auto" }}>
                    <div className="table-container">
                      <table className="invoice_table">
                        <thead>
                          <tr>
                            <th rowSpan="2" style={{ width: '30px', backgroundColor: '#D9FFE2' }}>
                              <input
                                type="checkbox"
                                checked={category.isChecked !== false}
                                onChange={(e) => handleJobCheckboxChange(category.id, e.target.checked)}
                                style={{ width: '15px', height: '15px', margin: '0 auto' }}
                              />
                            </th>
                            <th colSpan="11" style={{ backgroundColor: '#D9FFE2', padding: '10px', color: '#008B1F', textAlign: 'center' }}>
                              SALES
                            </th>
                          </tr>
                          <tr>
                            <th style={{ backgroundColor: '#D9FFE2', textAlign: 'center' }}>CHARGE CODE</th>
                            <th style={{ backgroundColor: '#D9FFE2', textAlign: 'center' }}>DESCRIPTION</th>
                            <th style={{ backgroundColor: '#D9FFE2', textAlign: 'center' }}>PO/WO NO</th>
                            <th style={{ backgroundColor: '#D9FFE2', textAlign: 'center' }}>PO/WO Date</th>
                            <th style={{ backgroundColor: '#D9FFE2', textAlign: 'center' }}>REMARKS</th>
                            <th style={{ backgroundColor: '#D9FFE2', textAlign: 'center' }}>ACCRUAL SPLIT</th>
                            <th style={{ backgroundColor: '#D9FFE2', textAlign: 'center' }}>CONTRACT VALUE</th>
                            <th style={{ backgroundColor: '#D9FFE2', textAlign: 'center' }}>QUANTITY</th>
                            <th style={{ backgroundColor: '#D9FFE2', textAlign: 'center' }}>RATE</th>
                            <th style={{ backgroundColor: '#D9FFE2', textAlign: 'center' }}>NET TOTAL</th>
                            <th style={{ backgroundColor: '#D9FFE2', textAlign: 'center', padding: '10px' }}>ATTACHMENT</th>
                          </tr>
                        </thead>
                        <tbody>
                          {category.rows.map((row, lineindex) => {
                            console.log("Row detailsssssssss", row);
                            console.log("contractId checkkkkkkkkkkkkk", category);

                            const rowContractId = row.contract_id !== undefined ? row.contract_id : category.contract_id;
                            const isNonContract = rowContractId == null;
                            const canEditChargeDetails = isNonContract;


                            // const canEditQuantityRate = canEditCharges;


                            console.log("row.contract_id:", row.contract_id);
                            console.log("rowContractId:", rowContractId);
                            console.log("canEditChargeDetails:", canEditChargeDetails);

                            return (
                              <tr key={lineindex}>
                                <td style={{ width: '30px' }}>
                                  <input
                                    type="checkbox"
                                    checked={row.isChecked !== false}
                                    onChange={(e) => handleCheckboxChange(e, category.id, lineindex)}
                                    style={{ width: '15px', height: '15px', margin: '0 auto' }}
                                  />
                                </td>
                                <td style={{ position: "relative" }}>
                                  <input
                                    style={{ margin: '0px', fontFamily: 'Work Sans', }}
                                    type="text"
                                    // value={inputValues[index]?.[lineindex] || ""}
                                    value={inputValues[index]?.[lineindex]?.split("-")[0]?.trim() || ""}
                                    onChange={(e) => {
                                      console.log("canEditChargeDetailsssssssssss", canEditChargeDetails);
                                      if (!canEditChargeDetails) return;
                                      const val = e.target.value;
                                      handleInputChange(e, index, lineindex, "chargecode");
                                      setInputValues((prev) => ({
                                        ...prev,
                                        [index]: {
                                          ...prev[index],
                                          [lineindex]: val,
                                        },
                                      }));
                                      fetchSuggestions(val, lineindex, index);
                                    }}
                                    onFocus={() => {
                                      if (!canEditChargeDetails) return;
                                      const list = suggestionsMap[index]?.[lineindex] || [];
                                      if (list.length > 0) {
                                        const list = suggestionsMap[index]?.[lineindex] || [];
                                        if (list.length > 0) {
                                          setShowSuggestionsMap(prev => ({ ...prev, [`${index}_${lineindex}`]: true }));
                                        }
                                      }
                                    }}
                                    onBlur={() => {
                                      setTimeout(() => {
                                        setShowSuggestionsMap(prev => ({ ...prev, [`${index}_${lineindex}`]: false }));
                                      }, 200);
                                    }}
                                    className="invoice_narrow_input_chargecode"
                                    placeholder="Search"
                                  // disabled={!canEditChargeDetails}
                                  />

                                  {showSuggestionsMap[`${index}_${lineindex}`] && suggestionsMap[index]?.[lineindex]?.length > 0 && (
                                    <ul
                                      style={{
                                        position: "absolute",
                                        top: "100%",
                                        left: 0,
                                        right: 0,
                                        backgroundColor: "white",
                                        border: "1px solid #ccc",
                                        zIndex: 999,
                                        maxHeight: "150px",
                                        overflowY: "auto",
                                        margin: 0,
                                        padding: 0,
                                        listStyle: "none",
                                      }}
                                    >
                                      {suggestionsMap[index]?.[lineindex].map((item) => (
                                        <li
                                          key={item.value}
                                          onMouseDown={() => {
                                            const selected = item.label;
                                            const chargeId = item.value;
                                            const supporting_doc = item.value1; // new


                                            setInputValues((prev) => ({
                                              ...prev,
                                              [index]: {
                                                ...prev[index],
                                                [lineindex]: selected,
                                              },
                                            }));

                                            setSelectedChargeIds((prev) => ({
                                              ...prev,
                                              [`${index}_${lineindex}`]: chargeId
                                            }));

                                            handleInputChange({ target: { value: selected } }, index, lineindex, "chargecode");
                                            setShowSuggestionsMap(prev => ({ ...prev, [`${index}_${lineindex}`]: false }));


                                            // ✨ NEW PART: split and set description separately ✨
                                            const splitParts = selected.split("-");
                                            const chargeCodeOnly = splitParts[0] || "";
                                            const descriptionOnly = splitParts.slice(1).join("-") || "";


                                            // Update charge code field value (CT002)
                                            setInputValues((prev) => ({
                                              ...prev,
                                              [index]: {
                                                ...prev[index],
                                                [lineindex]: chargeCodeOnly,
                                              },
                                            }));

                                            handleInputChange({ target: { value: chargeCodeOnly } }, index, lineindex, "chargecode");

                                            // Update description field value (TestCharge)
                                            handleInputChange({ target: { value: descriptionOnly } }, index, lineindex, "description");


                                            // 🔥 Update supporting doc flag in that row
                                            setAllCategories(prev =>
                                              prev.map((cat, catIndex) =>
                                                catIndex === index
                                                  ? {
                                                    ...cat,
                                                    rows: cat.rows.map((row, rIndex) =>
                                                      rIndex === lineindex
                                                        ? { ...row, supporting_document: !!supporting_doc }
                                                        : row
                                                    ),
                                                  }
                                                  : cat
                                              )
                                            );

                                          }}
                                          style={{
                                            padding: "8px",
                                            cursor: "pointer",
                                            borderBottom: "1px solid #eee",
                                          }}
                                        >
                                          {item.label}
                                        </li>
                                      ))}
                                    </ul>
                                  )}
                                </td>

                                <td>
                                  <input
                                    type="text"
                                    value={row.description}
                                    // onChange={(e) => handleInputChange(e, index, lineindex, "description")}
                                    onChange={(e) => {
                                      if (!canEditChargeDetails) return;
                                      handleInputChange(e, index, lineindex, "description");
                                    }}
                                    className="invoice_narrow_input_description"
                                    // disabled={!canEditChargeDetails}
                                    style={{ margin: '0px', fontSize: '13px', fontFamily: 'Work Sans', }}
                                  />
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    value={row.po_wo_number}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      if (value.length <= 10) {
                                        handleInputChange(e, index, lineindex, "po_wo_number");
                                      }
                                    }}
                                    className="invoice_narrow_input_quantity"
                                    style={{ margin: '0px', fontSize: '13px', fontFamily: 'Work Sans' }}
                                  />
                                </td>
                                <td>
                                  <input
                                    type="date"
                                    value={row.po_wo_date}
                                    onChange={(e) => handleInputChange(e, index, lineindex, "po_wo_date")}
                                    className="invoice_narrow_input_quantity"
                                    style={{ margin: '0px', fontSize: '13px', fontFamily: 'Work Sans' }}
                                  />
                                </td>
                                {/* <td>
                                  <input
                                    type="number"
                                    value={row.unitQuantity}
                                    // onChange={(e) => handleInputChange(e, index, lineindex, "unitQuantity")}
                                    onChange={(e) => {
                                      // if (!canEditQuantityRate) return;
                                      handleInputChange(e, index, lineindex, "unitQuantity");
                                    }}
                                    className="invoice_small_input"
                                    style={{ fontFamily: 'Work Sans' }}
                                  // disabled={!canEditQuantityRate}
                                  />
                                </td> */}
                                <td>
                                  <div
                                    className="table-tooltip-container"
                                    style={{ display: "flex", alignItems: "center", gap: "6px" }}
                                  >
                                    <input
                                      type="text"
                                      value={row.salesRemarks}
                                      onChange={(e) => {
                                        handleInputChange(e, index, lineindex, "salesRemarks");
                                      }}
                                      onKeyDown={(e) => {
                                        if (e.key === ",") e.preventDefault();
                                      }}
                                      className="invoice_narrow_input_remarks"
                                      style={{ margin: "0px", fontSize: "13px", fontFamily: "Work Sans" }}
                                    />

                                    {row.salesRemarks?.trim() && (
                                      <SquarePen
                                        size={16}
                                        onClick={() =>
                                          openRemarkPopup(index, lineindex, row.salesRemarks)
                                        }
                                      />
                                    )}
                                    <span className="add-contract-tooltip">
                                      {row.salesRemarks}
                                    </span>
                                  </div>
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    value={row.salesAccrual || 0} // From response data
                                    readOnly
                                    className="invoice_narrow_input"
                                    style={{ fontFamily: 'Work Sans' }}
                                  />
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    value={row.salesContractValue}
                                    disabled
                                    // onChange={(e) => handleInputChange(e, index, lineindex, "unitQuantity")}
                                    onChange={(e) => {
                                      // if (!canEditQuantityRate) return;
                                      handleInputChange(e, index, lineindex, "salesContractValue");
                                    }}
                                    className="invoice_narrow_input"
                                    style={{ fontFamily: 'Work Sans' }}
                                  />
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    value={row.salesunitQuantity}
                                    // onChange={(e) => handleInputChange(e, index, lineindex, "unitQuantity")}
                                    onChange={(e) => {
                                      // if (!canEditQuantityRate) return;
                                      handleInputChange(e, index, lineindex, "salesunitQuantity");
                                    }}
                                    className="invoice_narrow_input_quantity"
                                    style={{ fontFamily: 'Work Sans' }}
                                  // disabled={!canEditQuantityRate}
                                  />
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    value={row.salesRate || ""} // From response data
                                    onChange={(e) => {
                                      handleInputChange(e, index, lineindex, "salesRate");
                                    }}
                                    className="invoice_narrow_input"
                                    style={{ fontFamily: 'Work Sans' }}
                                  />
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    value={row.salesNetTotal || ""} // From response data
                                    readOnly
                                    className="invoice_narrow_input"
                                    style={{ fontFamily: 'Work Sans' }}
                                  />
                                </td>
                                {/* <td>
                                  <input
                                    type="number"
                                    value={row.unitRatePrice}
                                    // onChange={(e) => handleInputChange(e, index, lineindex, "unitRatePrice")}
                                    onChange={(e) => {
                                      // if (!canEditQuantityRate) return;
                                      handleInputChange(e, index, lineindex, "unitRatePrice");
                                    }}
                                    className="invoice_small_input"
                                  // disabled={!canEditQuantityRate}
                                  />
                                </td> */}
                                {/* <td>
                                  <input
                                    type="number"
                                    value={row.netTotal}
                                    readOnly
                                    className="invoice_small_input"
                                  />
                                </td> */}
                                <td className="attachment-cell">
                                  {/* Upload or View */}
                                  {!row.uploadedFiles || row.uploadedFiles.length === 0 ? (
                                    row.attachment ? (
                                      <div className="attachment_view_section">
                                        <a
                                          href={row.attachment}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          className="view_link"
                                        >
                                          <i className="fa fa-eye" style={{ marginRight: "5px" }}></i>
                                          <span className="view_text">View</span>
                                        </a>
                                        <button
                                          className="remove_file_btn"
                                          onClick={() => handleRemoveAttachment(category.id, index, lineindex)}
                                        >
                                          ⨉
                                        </button>
                                      </div>
                                    ) : (
                                      <label className="file_upload">
                                        <input
                                          type="file"
                                          multiple
                                          onChange={(e) => handleFileUpload(e, category.id, index, lineindex)}
                                          style={{ display: "none" }}
                                        />
                                        <img src={upload_icon} alt="Upload" className="upload_icon" />
                                        <span className="upload_text">
                                          Upload{" "}
                                          {row.supporting_document && (
                                            <span style={{ color: "red" }}>(Required*)</span>
                                          )}
                                        </span>
                                      </label>
                                    )
                                  ) : null}

                                  {/* Uploaded Files */}
                                  {row.uploadedFiles && row.uploadedFiles.length > 0 && (
                                    <div className="uploaded_files">
                                      {row.uploadedFiles.map((file, fileIndex) => (
                                        <div key={fileIndex} className="uploaded_file_item">
                                          <img
                                            src={
                                              file.name.endsWith(".xls") || file.name.endsWith(".xlsx")
                                                ? excel_icon
                                                : upload_icon
                                            }
                                            alt="File"
                                            className="file_icon"
                                          />
                                          <span className="file_name">{file.name}</span>
                                          <button
                                            className="remove_file_btn"
                                            onClick={() =>
                                              handleRemoveFile(category.id, index, lineindex, fileIndex)
                                            }
                                          >
                                            ⨉
                                          </button>
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                </td>
                                <td
                                  style={{
                                    position: 'sticky',
                                    right: 0,
                                    background: 'white',
                                    zIndex: 1,
                                    textAlign: 'center',
                                    padding: 0,
                                    boxShadow: '-2px 0 5px rgba(0,0,0,0.1)'
                                  }}
                                > <button style={{ background: 'white' }} onClick={() => deleteRow(category.id, lineindex)}>
                                    <img src={delete_icon} alt="Delete" className="delete_icon" />
                                  </button></td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                      {/* {category.contract_id == null && ( */}
                      {/* <div className="static-delete-container">
                        {category.rows.map((row, index) => (
                          <div key={index} className="static-delete-btn">
                            <button onClick={() => deleteRow(category.id, index)}>
                              <img src={delete_icon} alt="Delete" className="delete_icon" />
                            </button>
                          </div>
                        ))}
                      </div> */}
                      {/* )} */}
                    </div>

                    {/* {category.contract_id == null && ( */}
                    <div
                      className="add_new_row"
                      onClick={() => addRow(category.id)}
                      style={{ cursor: "pointer" }}
                    >
                      <span className="add_new_row_popup">
                        <img src={plus_icon} alt="" />
                        Add Row
                      </span>
                    </div>
                    {/* )} */}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <MergedCharges
        isOpen={isMergedListPopupOpen}
        onClose={handleClosePopup}
        mergedChargesData={mergedChargesData}
        allCategories={allCategories}
        projectId={projectId}
        selectedChargeIds={selectedChargeIds}
        backdatedDays={backdatedDays}
      />
      <SeparateInvoice
        isOpen={isSeparateInvoicePopupOpen}
        onClose={() => setIsSeparateInvoicePopupOpen(false)}
        separateChargesData={separateChargesData}
        loading={isLoading}
        backdatedDays={isSeparateInvoicePopupOpen.backdatedDays}
        projectId={projectId}
        allCategories={allCategories}
        selectedChargeIds={selectedChargeIds}
      />
      <ConfirmDialog
        open={showMergeConfirm}
        title="Confirm Merge"
        message="Are you sure? After merging, the charge line items cannot be edited"
        confirmText="Yes, Merge"
        cancelText="Cancel"
        onConfirm={handleConfirmAction}
        onCancel={() => {
          setShowMergeConfirm(false);
          setConfirmAction(null);
        }}
      />
      <CommonFooter />
      <CommonRemarkPopup
        show={showRemarkPopup}
        onClose={() => setShowRemarkPopup(false)}
        onSave={handleSaveRemark}
        initialValue={remarkValue}
        title="Sales Remarks"
      />
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
    </>
  )
}

export default GenerateSalesInvoice;